import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectHeaderState } from "../../redux/slices/headerSlice";
import { RoutesMap } from "../../types";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { useAuthStore } from "../../hooks";
import { Role } from "../../types/roles/roleTypes";
import { useEnergieStore } from "../../hooks/useEnergie";
import { Energie } from "../../types/slices/energieType";
import { useMainStagesWorksStore } from "../../hooks/useMainStagesWorks";

const EnergiesList: FC = () => {
    const navigate = useNavigate()
    const { user } = useAuthStore()
    const { search } = useSelector(selectHeaderState)
    const { status, energies, getEnergie, deleteEnergieStore, setSelectedEnergie } = useEnergieStore()
    const { getMainStagesWorks, mainStagesWorks } = useMainStagesWorksStore()

    const [loading, setLoading] = useState<boolean>(false)
    const [page, setPage] = useState<number>(0)
    const [rowsPerPage, setRowsPerPage] = useState<number>(10)
    const [rowSelected, setRowSelected] = useState<Energie>({} as Energie)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const userRole: Role | any = user.userType

    const columns = [
        { type: 'options', field: 'options', label: 'OPCIONES', align: 'center' },
        { type: 'text', field: 'name', label: 'NOMBRES', align: 'center' },
        { type: 'text', field: 'main_stages', label: 'ETAPAS PRINCIPALES DE TRABAJO', align: 'center', format: (row) => row.main_stages?.map((element) => element).join(' - ') },
        { type: 'detail', field: 'detail', label: '', align: 'center' },
    ]

    useEffect(() => {
        getEnergieApi()
    }, [search])

    const getEnergieApi = async () => {
        try {
            setLoading(true)
            let payload: any = {}
            if (search !== '') {
                payload = {
                    ...payload,
                    name: search
                }
            }
            await getEnergie(payload)
            // await getMainStagesWorks();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const onAdd = () => {
        setSelectedEnergie({} as Energie)
        navigate({ pathname: RoutesMap.ENERGIES_FORM })
    }

    const onEdit = (rowSelected) => {
        setSelectedEnergie(rowSelected)
        navigate({ pathname: RoutesMap.ENERGIES_FORM })
    }

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true);
    }

    const onDeleteConfirm = async () => {
        const response = await deleteEnergieStore(rowSelected.id)
        if (response === true) {
            setSelectedEnergie({} as Energie)
            setShowModalConfirm(false)
            getEnergieApi()
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <>
            <Grid item xs={12}>
                {userRole === Role.ADMIN && (
                    <CustomTable
                        title={'Energías'}
                        columns={columns || []}
                        loading={loading}
                        rows={energies || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
                {userRole === Role.MAINTENANCE && (
                    <CustomTable
                        title={'Energías'}
                        columns={columns || []}
                        loading={loading}
                        rows={energies || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
            </Grid>
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false) }}
                        onCancel={() => { setShowModalConfirm(false) }}
                        onConfirm={onDeleteConfirm}
                        status2={status === ApiStatus.FETCHING ? true : false}
                    />
                )
            }
        </>
    )
}

export default EnergiesList

